import { createAction, props } from '@ngrx/store';
import type { PlatformAdminData } from './platform-identity.models';

export const setAdmin = createAction(
  '[PlatformIdentity] Set Admin',
  props<{ admin: PlatformAdminData | null }>()
);

export const validateFailed = createAction(
  '[PlatformIdentity] Validation Failed',
  props<{ error: string }>()
);
